import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=ef118274&scoped=true&"
import script from "./Prescription.vue?vue&type=script&lang=js&"
export * from "./Prescription.vue?vue&type=script&lang=js&"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=ef118274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef118274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
